import React from 'react';
import PropTypes from 'prop-types';
import { Zap } from 'lucide-react';
import { isUK, isIreland } from '../../utils/countries';

import './EnergyRating.scss';

/**
 * Get color class for EPC/BER rating
 * A/A1-A3 = green, B = light green, C = yellow-green, D = yellow, E = orange, F = dark orange, G = red
 */
var getRatingColor = function(rating) {
    if (!rating) return '';
    var letter = rating.charAt(0).toUpperCase();
    var colors = {
        'A': 'al-energy-rating--a',
        'B': 'al-energy-rating--b',
        'C': 'al-energy-rating--c',
        'D': 'al-energy-rating--d',
        'E': 'al-energy-rating--e',
        'F': 'al-energy-rating--f',
        'G': 'al-energy-rating--g'
    };
    return colors[letter] || '';
};

/**
 * EnergyRating Component
 * Displays EPC (UK) or BER (Ireland) energy rating as a colored badge
 */
var EnergyRating = function(props) {
    var countryId = props.countryId;
    var epcRating = props.epcRating;
    var berRating = props.berRating;

    // Only show for UK (EPC) or Ireland (BER)
    var rating = null;
    var label = null;

    if (isUK(countryId) && epcRating) {
        rating = epcRating;
        label = 'EPC';
    } else if (isIreland(countryId) && berRating) {
        rating = berRating;
        label = 'BER';
    }

    if (!rating) return null;

    var colorClass = getRatingColor(rating);

    return (
        <div className="al-energy-rating-container">
            <div className="al-energy-rating-label">
                <Zap size={16} />
                <span>Energy Rating ({label})</span>
            </div>
            <div className={'al-energy-rating-badge ' + colorClass}>
                {rating}
            </div>
        </div>
    );
};

EnergyRating.propTypes = {
    countryId: PropTypes.number,
    epcRating: PropTypes.string,
    berRating: PropTypes.string
};

export default EnergyRating;
